var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHornIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.16671 20.9999C12.4445 20.9999 16.7223 20.9999 21 20.9999C25.6667 20.9999 31.1112 17.111 37.3334 9.33325V44.3333C31.1112 36.5555 25.6667 32.6666 21 32.6666C16.7223 32.6666 12.4445 32.6666 8.16671 32.6666C4.94505 32.6666 2.33337 30.0549 2.33337 26.8333C2.33337 23.6116 4.94505 20.9999 8.16671 20.9999Z",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33337 32.6667L14 46.6667H23.3334L18.6667 32.6667H9.33337Z",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  strokeLinecap: "square"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6666 21V32.6667",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M42 37.3334C46.8669 32.4665 46.8669 23.5337 42 18.6667M46.6667 44.3334C55.9662 35.0339 56.0179 21.018 46.6667 11.6667",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeLinejoin: "round"
})));
export { SvgHornIcon as ReactComponent };
export default __webpack_public_path__ + "assets/5e26a0a3.svg";